import styled from 'styled-components';
import { FlexView } from '@cuemath/comps';
import COLORS from 'constants/colors';

export const DetectionItemWrapper = styled(FlexView)`
  padding: 12px 16px;
  cursor: pointer;
  border-radius: 8px;
  border: 2px solid ${({ isActive }) => (isActive ? COLORS.BLACK : COLORS.BLACK_T_08)};
  background: ${({ isActive }) => (isActive ? COLORS.WHITE : 'transparent')};
  transition: background 0.15s ease;
  box-shadow: ${({ isActive }) =>
    isActive ? '0px 6px 8px rgba(0, 0, 0, 0.15)' : '0px 2px 4px rgba(0, 0, 0, 0.1)'};
  margin-bottom: 16px;
  transition: 0.3s ease;
  &:hover {
    border-color: ${COLORS.BLACK};
    box-shadow: 0px 6px 8px rgba(0, 0, 0, 0.15);
  }
`;

export const ProgressBarWrapper = styled(FlexView)`
  width: 100%;
  height: 6px;
  background-color: ${COLORS.GREY_2};
  border-radius: 4px;

  overflow: hidden;
`;

export const ProgressBarFill = styled(FlexView)`
  height: 100%;
  width: ${({ percent }) => percent}%;
  border-radius: 2px;
  transition: width 0.3s ease;
  background: linear-gradient(
    45deg,
    ${({ bgColor }) => bgColor},
    ${({ color }) => color}
  );
`;

export const LabelRow = styled(FlexView)`
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;

export const ColorDot = styled.span`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: ${({ color }) => color};
  flex-shrink: 0;
`;

export const VerdictLabelWrapper = styled(FlexView)`
  width: fit-content;
  border-radius: 8px;
  background: ${({ bg }) => bg || 'transparent'};
`;
